import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject, Subscription, catchError, forkJoin, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { SidebarMenuComponent } from "../sidebar-menu/sidebar-menu.component";
import { MobileMenuComponent } from "../mobile-menu/mobile-menu.component";
import { LocalstorageService } from '../../services/localstorage.service';
import { DataCourse } from 'src/app/shared/interfaces/course.interface';
import { CoursesService } from 'src/app/services/courses.service';
import { ContentService } from 'src/app/services/content.service';
import { DataLesson } from 'src/app/shared/interfaces/lesson.interface';
import { daysUntilDue } from 'src/app/shared/functions';
import { LessonsService } from 'src/app/services/lessons.service';
import { LoaderComponent } from "../loader/loader.component";
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Component({
    selector: 'app-navbar',
    standalone: true,
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [CommonModule, SidebarMenuComponent, RouterModule, MobileMenuComponent, FormsModule, LoaderComponent]
})
export class NavbarComponent {
  isLoading: boolean = true;
  dropdown:boolean = false;
  isMenuOpen:boolean = false;
  isExpanded:boolean = false;
  infoUser: any;
  activitiesExpired: DataLesson[] = []
  activitiesCloseToExpired: DataLesson[] = []
  user: any;
  imgUser: string | null = '';
  searchTerm: string = '';
  suggestedCategories: any = [];
  categories: DataCourse[] = [];
  reloadNotifications: Subscription;
  stopLoader: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router, private cookieService: SsrCookieService, private authService: AuthService, private localStorage: LocalstorageService, private coursesService: CoursesService,
    private content: ContentService, private lessonsService: LessonsService) {
      this.reloadNotifications = this.content.reloadNotifications$.subscribe({
        next: resp => {
          if(resp) this.getActivitesForNotifications();
        },
        error: () => {
          this.isLoading = false;
        }
      })
      this.stopLoader = this.content.bool$.subscribe({
        next: resp => {
          if(resp) this.isLoading = false;
        }
      })
    }

  ngOnInit(){
    this.infoUser = this.localStorage.getCurrentUserProfileAsJson();
    this.user = this.localStorage.getCurrentUserAsJson();
    this.getActivitesForNotifications();
    if(this.localStorage.getItem('userImg')){
      this.imgUser = this.localStorage.getItem('userImg');
    }
    this.coursesService.getAllCategories().pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: (categories: DataCourse[]) => {
          this.categories = categories;
        },
        error: error =>{
          console.error('Error trayendo las categorías de todos los cursos', error)
        }
      }
    )

    this.localStorage.watchStorage().pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: (itemName: string | null) => {
          if (itemName === 'profile_current_user') {
            this.infoUser = this.localStorage.getCurrentUserProfileAsJson();
          } else if (itemName === 'userImg') {
            this.imgUser = this.localStorage.getItem('userImg');
          }
        },
        error: error => {
          console.error('Error en el local storage', error)
        }
      }
    );
  }
  // logout(){
  //   this.authService.logout()
  //   this.router.navigate(['/login']);
  // }

  // Logout with cookie
  // logout(){
  //   this.authService.logoutWithCookie(localStorage.getItem('logout_token_edutegia'),
  //   localStorage.getItem('global_token_edutegia')).pipe(takeUntil(this.destroy$))
  //   .subscribe(
  //     {
  //       next: (resp:any) => {
  //         // console.log("logout")
  //         if(resp===null){
  //           this.router.navigate(['/login']);
  //         }
  //       },
  //       error : error => {
  //         console.error('Error cerrando sesión', error)
  //       }
  //     }
  //   );
  // }
  logout(){
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll('/', 'https://escuela.aprendity.com');
    this.cookieService.deleteAll('/', 'localhost');
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  getActivitesForNotifications(): void {
    this.content.allActivities$.pipe(
      takeUntil(this.destroy$),
      switchMap(courses => {
        console.log(courses)
        console.log(this.user)
        const courseObservables = courses
          .filter(course => course.activities && course.activities.length > 0)
          .map(course => {
              const activityObservables = course.activities.map((activity:any) => {
                return this.content.isActivitySent(this.user.uid, activity.attributes.drupal_internal__nid).pipe(
                    map(response => !!response.length),
                    catchError(() => of(false)),
                    map(isSent => ({
                        ...activity,
                        isSent: isSent
                    }))
                );
              });
              return forkJoin(activityObservables).pipe(
                map((activities:any) => {
                    return activities.filter((activity:any) => !activity.isSent);
                }),
                map(filteredActivities => {
                    return {
                        ...course,
                        activities: filteredActivities
                    };
                })
              );
          });

        return forkJoin(courseObservables);
      })
    ).subscribe(
      {
        next: filteredCourses => {
          this.isLoading = false;
          this.content.setfilteredActivities(filteredCourses);
          this.content.executeInLearningZone$.next(true);
          this.notifications();
        },
        error: error => {
          this.isLoading = false;
          console.error('error trayendo todas las actividades', error)
        }
      }
    );
  }

  getActivityWithLessonPath(activity: DataLesson) {
    return this.lessonsService.getLessonById(activity.relationships.field_lesson?.data?.id).pipe(
      map(lesson => {
        activity.lessonPath = lesson.attributes.path.alias;
        return activity;
      })
    );
  }

  notifications(): void {
    this.content.filteredActivities$
      .pipe(
        takeUntil(this.destroy$),
        switchMap(courses =>
          forkJoin(
            courses.map(course => {
              if (course.activities.length === 0) {
                return of({ ...course, activities: [] });
              }
              return forkJoin(
                course.activities.map((activity: any) =>
                  this.getActivityWithLessonPath(activity)
                )
              ).pipe(
                map(activities => ({ ...course, activities }))
              );
            })
          )
        ),
        map((courses: any) =>
          courses.flatMap((course: any) =>
            course.activities.map((activity: any) => ({
              ...activity,
              courseTitle: course.title,
              coursePath: course.path,
              daysLeft: daysUntilDue(activity.attributes.field_date_range.end_value)
            }))
          )
        ),
        tap((activitiesWithDaysLeft: any[]) => {
          this.content.activitiesForNotifications$.next(activitiesWithDaysLeft);
          activitiesWithDaysLeft.forEach(activity => {
            if ([3, 1].includes(activity.daysLeft) && !this.activitiesCloseToExpired.some(existingActivity => existingActivity.id === activity.id)) {
              this.activitiesCloseToExpired.push(activity);
            }
            if (activity.daysLeft < 0 && !this.activitiesExpired.some(existingActivity => existingActivity.id === activity.id)) {
              this.activitiesExpired.push(activity);
            }
          });
        })

      )
      .subscribe({
        error: error => console.error('Error trayendo las actividades completas para las notificaciones', error)
      });
  }


  // logout(){
  //   this.authService.onLogout(
  //     localStorage.getItem('logout_token_edutegia'),
  //     localStorage.getItem('global_token_edutegia')
  //     ).subscribe((resp:any) => {
  //       console.log("logout")
  //       console.log(resp)
  //       if(resp===null){
  //         localStorage.removeItem('logout_token_edutegia');
  //         localStorage.removeItem('login_csrf_token_edutegia');
  //         localStorage.removeItem('current_user_edutegia');
  //         this.router.navigate(['/login']);
  //       }
  //   },(e: HttpErrorResponse) => {
  //     console.log("logout e.status ",e )
  //     if(e.status == 403 || e.status == 200){
  //     //  alert("")
  //     }
  //     console.log(typeof e.status)});
  // }

    // this.authService.logout().subscribe((resp) => {
    //   console.log(resp);
    //   localStorage.clear();
    //   this.router.navigate(['/login']);
    // });

  searchCourses() {
    this.router.navigate(['/cursos'], { queryParams: { category: this.searchTerm } });
    this.isExpanded = false;
  }

  setDefaultImage(event:any) {
    event.target.src = '../../../assets/images/user.png';
  }

  onSearchTermChange() {
    if (!this.searchTerm.trim()) {
      this.suggestedCategories = [];
      return;
    }
    this.suggestedCategories = this.categories.filter(cat =>
      cat['attributes'].name.toLowerCase().startsWith(this.searchTerm.toLowerCase())
    ).map(cat => cat['attributes'].name);
  }

  selectSuggestion(suggestion: string) {
    this.searchTerm = suggestion;
    this.suggestedCategories = [];
    this.router.navigate(['/cursos'], { queryParams: { category: suggestion } });
    this.isExpanded = false;
  }

  toggleSearch() {
    this.isExpanded = !this.isExpanded;
  }

  closeSearch() {
    this.isExpanded = false;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}

